import React from "react";
import { Link } from "react-router-dom";
import SsoLoginCallBack from "Utils/SsoLoginCallBack";



const SsoCallBackKakao = () => {
    SsoLoginCallBack("kakao");
    return(
        <>
        </>
    )
}

export default SsoCallBackKakao;